import { render, staticRenderFns } from "./IconChevronRightCircle.vue?vue&type=template&id=3ba8be46&scoped=true&"
import script from "./IconChevronRightCircle.vue?vue&type=script&lang=js&"
export * from "./IconChevronRightCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba8be46",
  null
  
)

export default component.exports